import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { LanguageSkills } from '../types/entities/LanguageSkills';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import {SPTextField} from "../components/Table/fields/SPTextField";
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SetField } from '../components/Table/fields/SetField';
import { SPSetField } from '../components/Table/fields/SPSetField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
export const languageSkills: SchemaWithClient<LanguageSkills> = {
  name: 'Language Skills',
  pluralName: 'Language Skills',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    /* guide: {
      name: 'Guide',
      required: true,
      fieldRenderer: SelectField.tableAdapter(enumItems.guide),
      switchboard: true,
    },*/
    language: {
      name: 'Language',
      fieldRenderer: SelectField.tableAdapter(enumItems.language),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.language),
      switchboard: true,
      url: enumItems.language.client.getAllPath,
      tempSchema: enumItems.language,
    },
    level: {
      name: 'Level',
      fieldRenderer: SelectField.tableAdapter(enumItems.languageLevel),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.languageLevel),
      switchboard: true,
      url: enumItems.languageLevel.client.getAllPath,
      tempSchema: enumItems.languageLevel,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/language-skills'),
};
